import { SimpleGrid } from "@mantine/core";

interface DividerGridProps {
  columns?: 2 | 3 | 4;
  children: any;
}

export const DividerGrid = ({ children, columns = 3, ...rest }: DividerGridProps) => {
  const cols =
    columns === 4
      ? { base: 1, md: 2, lg: 4 }
      : columns === 3
        ? { base: 1, sm: 2, lg: 3 }
        : { base: 1, md: 2 }; // columns === 2

  return (
    <SimpleGrid cols={cols} {...rest}>
      {children}
    </SimpleGrid>
  );
};
